import React, { useState } from 'react'
import { TouchableOpacity, View, Image, Text, PixelRatio } from 'react-native'
import { StyleSheet } from 'react-native'
import { Feather } from '@expo/vector-icons'
import theme from '../../../theme'
import styles from './ProfileSectionStyles'

export const ProfileSection = ({ sectionName, show }) => {
    const fontScale = 1 // Obtiene el factor de escala
    const iconSize = 20 * fontScale // Ajusta el tamaño del ícono según la escala

    return (
        /*
        <View style={styles.container}>
            <TouchableOpacity onPress={show} style={styles.accordion}>
                <View style={styles.accordionLabel}>
                    <Text style={styles.accordionText}>{sectionName}</Text>
                    <Feather name='chevron-down' size={22} color={theme.colors.colorPrimary} />
                </View>
            </TouchableOpacity>
        </View>
        */
        <TouchableOpacity
            style={[styles.containerRow, styles.spaceBetween]}
            onPress={show}
        >
            <Text style={styles.mainButtonColorText}>{sectionName}</Text>
            <Feather
                name='chevron-right'
                size={iconSize}
                color={theme.colors.textPrimary}
            />
        </TouchableOpacity>
    )
}
